import {Navigate, useParams} from 'react-router';
import {placeHref} from '../../../screens/myWeather/placeHref';

/**
 * Any other page of a place: its Dashboard. Absolute, from the id: a
 * relative `to` in a splat route resolves against the splat itself, and
 * would send the page to itself.
 */
const ToPlaceDashboard = () => {
  const {placeId = ''} = useParams();
  return <Navigate to={placeHref({hash: placeId})} replace />;
};

export default ToPlaceDashboard;
